// extracted by mini-css-extract-plugin
module.exports = {"root":"GeolocationInfo_root__2InH-","city":"GeolocationInfo_city__30jtq","distance":"GeolocationInfo_distance__lgrbh","separator":"GeolocationInfo_separator__1Hf5e"};